<script>
  import { createEventDispatcher } from 'svelte';
  export let mobile = false;
  export let postInformation;
  export let viewType;
  let instagram = postInformation['platform'] == 'instagram';
  let author = postInformation['author'];
  let showPlatformBottom = viewType == 'embed-post' || mobile;
  const dispatch = createEventDispatcher();
  let handleRegularClick = function () {
    dispatch('click');
  };
</script>

<style style="text/scss" lang="scss">
  .platform-icon-top {
    top: 10px;
    left: 10px;
    position: absolute;
    z-index: 2;
  }
  .post-information {
    position: absolute;
    left: 16px;
    bottom: 50px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    width: calc(100% - 32px);
    z-index: 1;
    .author-information {
      display: flex;
      align-items: center;
      gap: 16px;
      align-self: stretch;
      .icon-container {
        position: relative;
        width: 37px;
        height: 34px;
        align-items: center;
        flex-shrink: 0;
        .author-icon {
          position: absolute;
          border-radius: 99px;
          border: 1px solid white;
          left: 0px;
          top: 0px;
          width: 32px;
          height: 32px;
        }
        .platform-icon {
          position: absolute;
          right: 0px;
          bottom: 0px;
          width: 16px;
          height: 16px;
        }
      }
      .name-container {
        display: flex;
        align-items: center;
        gap: 4px;
        .name {
          color: #fff;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: 20px; /* 142.857% */
        }
        .verified-icon {
          width: 16px;
          height: 16px;
          fill: #fff;
        }
      }
    }
    .title {
      width: 100%;
      color: #fff;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 142.857% */
      text-overflow: ellipsis;
      overflow: hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      display: -webkit-box;
    }
  }
</style>

{#if !showPlatformBottom}
  <div class="platform-icon-top">
    {#if instagram}
      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="27" viewBox="0 0 26 27" fill="none">
        <circle cx="13" cy="13.7559" r="12.5" fill="white" stroke="white" />
        <path
          d="M13.0558 16.1842C11.7377 16.1842 10.6679 15.0993 10.6679 13.7558C10.6679 12.4123 11.7377 11.3274 13.0558 11.3274C14.3739 11.3274 15.4436 12.4123 15.4436 13.7558C15.4436 15.0993 14.3739 16.1842 13.0558 16.1842Z"
          fill="url(#paint0_radial_548_86418)" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.9506 7.82415C14.0358 7.73419 12.1035 7.7459 10.1884 7.82304L10.161 7.82415C9.46645 7.85457 9.08622 7.97117 8.83273 8.07256C8.20258 8.32081 7.71836 8.82197 7.47405 9.45153C7.37266 9.71009 7.25605 10.0954 7.22564 10.8052C7.13554 12.7616 7.13554 14.7398 7.22564 16.6962C7.26112 17.406 7.37773 17.7913 7.47405 18.0498C7.71799 18.6784 8.20393 19.1811 8.83273 19.4288C9.08622 19.5251 9.46138 19.6468 10.161 19.6772C12.0834 19.7675 14.0282 19.7675 15.9506 19.6772C16.6452 19.6468 17.0254 19.5302 17.2789 19.4288C17.909 19.1805 18.3932 18.6794 18.6376 18.0498C18.7389 17.7913 18.8555 17.406 18.886 16.6962C18.9761 14.7398 18.9761 12.7616 18.886 10.8052C18.8505 10.0954 18.7339 9.71009 18.6376 9.45153C18.3936 8.82292 17.9077 8.32028 17.2789 8.07256C17.0254 7.97624 16.6502 7.85457 15.9506 7.82415ZM13.0558 10.0143C11.0228 10.0143 9.38024 11.6873 9.38024 13.7558C9.38024 15.8242 11.0279 17.4973 13.0558 17.4973C15.0837 17.4973 16.7313 15.8242 16.7313 13.7558C16.7313 11.6873 15.0837 10.0143 13.0558 10.0143ZM17.7351 9.86725C17.7351 10.3488 17.3515 10.7392 16.8784 10.7392C16.4052 10.7392 16.0216 10.3488 16.0216 9.86725C16.0216 9.38566 16.4052 8.99525 16.8784 8.99525C17.3515 8.99525 17.7351 9.38566 17.7351 9.86725Z"
          fill="url(#paint1_radial_548_86418)" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1 14.1005V13.4516C1.18251 6.72405 7.03802 1.4363 13.6286 1.77091C19.7529 2.08523 24.8378 7.17525 25 13.4516V14.0904C24.8378 20.2552 19.9252 25.2844 13.943 25.7559H12.1128C6.16603 25.2894 1.1673 20.3059 1 14.1005ZM10.1052 6.51615C12.066 6.42465 14.0456 6.42465 16.0064 6.51615C16.7668 6.55164 17.289 6.67332 17.7453 6.85583C18.7121 7.2405 19.4676 8.0203 19.8391 8.99019C20.0165 9.4566 20.1382 9.98386 20.1737 10.7595L20.1741 10.7713C20.2522 12.7626 20.2648 14.7711 20.1737 16.7621C20.1382 17.5378 20.0165 18.0701 19.8391 18.5314C19.471 19.5027 18.711 20.2816 17.7453 20.6658C17.289 20.8483 16.7668 20.97 16.0064 21.0055C14.0456 21.097 12.0661 21.0964 10.1052 21.0055C9.34477 20.97 8.82259 20.8483 8.36632 20.6658C7.39946 20.2811 6.64398 19.5013 6.27253 18.5314C6.09509 18.065 5.97342 17.5378 5.93793 16.7621L5.93747 16.7503C5.85937 14.759 5.84684 12.7505 5.93793 10.7595C5.97342 9.98386 6.09509 9.45153 6.27253 8.99019C6.64059 8.0189 7.40056 7.24006 8.36632 6.85583C8.82259 6.67332 9.34477 6.55164 10.1052 6.51615Z"
          fill="url(#paint2_radial_548_86418)" />
        <defs>
          <radialGradient
            id="paint0_radial_548_86418"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(1.43834 23.5548) rotate(-86.9999) scale(34.6986 29.4932)">
            <stop stop-color="#FED576" />
            <stop offset="0.2634" stop-color="#FF6E2A" />
            <stop offset="0.6091" stop-color="#E42995" />
            <stop offset="1" stop-color="#4864EF" />
          </radialGradient>
          <radialGradient
            id="paint1_radial_548_86418"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(1.43834 23.5548) rotate(-86.9999) scale(34.6986 29.4932)">
            <stop stop-color="#FED576" />
            <stop offset="0.2634" stop-color="#FF6E2A" />
            <stop offset="0.6091" stop-color="#E42995" />
            <stop offset="1" stop-color="#4864EF" />
          </radialGradient>
          <radialGradient
            id="paint2_radial_548_86418"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(1.43834 23.5548) rotate(-86.9999) scale(34.6986 29.4932)">
            <stop stop-color="#FED576" />
            <stop offset="0.2634" stop-color="#FF6E2A" />
            <stop offset="0.6091" stop-color="#E42995" />
            <stop offset="1" stop-color="#4864EF" />
          </radialGradient>
        </defs>
      </svg>
    {:else}
      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1 13.3447V12.6957C1.18251 5.96819 7.03802 0.680444 13.6286 1.01505C19.7529 1.32937 24.8378 6.41939 25 12.6957V13.3345C24.8378 19.4993 19.9252 24.5285 13.943 25H12.1128C6.16603 24.5336 1.1673 19.55 1 13.3447Z"
          fill="black" />
        <path
          d="M15.8237 11.1801C16.6655 11.784 17.6968 12.1393 18.8106 12.1393V9.98833C18.5998 9.98838 18.3895 9.96632 18.1833 9.92247V11.6156C17.0696 11.6156 16.0384 11.2603 15.1964 10.6564V15.0459C15.1964 17.2418 13.4226 19.0218 11.2347 19.0218C10.4183 19.0218 9.65953 18.7741 9.02921 18.3493C9.74862 19.0875 10.7519 19.5454 11.8618 19.5454C14.0499 19.5454 15.8237 17.7655 15.8237 15.5695L15.8237 11.1801ZM16.5975 9.01C16.1673 8.53831 15.8848 7.92873 15.8237 7.25482V6.97816H15.2292C15.3788 7.8347 15.8892 8.56647 16.5975 9.01ZM10.4131 16.6643C10.1727 16.348 10.0428 15.9611 10.0434 15.5632C10.0434 14.5589 10.8547 13.7446 11.8556 13.7446C12.0422 13.7446 12.2276 13.7732 12.4054 13.8298V11.6308C12.1976 11.6022 11.988 11.5901 11.7784 11.5945V13.3062C11.6005 13.2496 11.415 13.2208 11.2284 13.221C10.2274 13.221 9.41616 14.0352 9.41616 15.0396C9.41616 15.7499 9.82168 16.3647 10.4131 16.6643Z"
          fill="#FF004F" />
        <path
          d="M15.1964 10.6564C16.0384 11.2603 17.0696 11.6156 18.1833 11.6156V9.92247C17.5616 9.78957 17.0113 9.46349 16.5975 9.01C15.8892 8.56647 15.3788 7.8347 15.2292 6.97816H13.6677V15.5694C13.6641 16.571 12.8542 17.382 11.8554 17.382C11.2669 17.382 10.7442 17.1004 10.4131 16.6643C9.82168 16.3647 9.41616 15.7499 9.41616 15.0396C9.41616 14.0352 10.2274 13.221 11.2284 13.221C11.4201 13.221 11.605 13.251 11.7784 13.3062V11.5945C9.62888 11.6391 7.89995 13.4017 7.89995 15.5695C7.89995 16.6516 8.33052 17.6325 9.02921 18.3493C9.65953 18.7741 10.4183 19.0218 11.2347 19.0218C13.4226 19.0218 15.1964 17.2418 15.1964 15.0459V10.6564Z"
          fill="white" />
        <path
          d="M18.1833 9.92247L18.1832 9.46463C17.6226 9.46548 17.0731 9.30795 16.5975 9.01C17.0185 9.47261 17.573 9.7916 18.1833 9.92247ZM15.2292 6.97816C15.2149 6.8963 15.2039 6.81392 15.1963 6.73121V6.45455H13.0404V15.0459C13.0369 16.0473 12.227 16.8583 11.2282 16.8583C10.9349 16.8583 10.6583 16.7884 10.4131 16.6643C10.7442 17.1004 11.2669 17.382 11.8554 17.382C12.8542 17.382 13.6641 16.571 13.6677 15.5694V6.97816H15.2292ZM11.7784 11.5945L11.7783 11.1072C11.5981 11.0825 11.4165 11.0701 11.2347 11.0702C9.0465 11.0701 7.27273 12.8502 7.27273 15.0459C7.27273 16.4225 7.96988 17.6357 9.02921 18.3493C8.33052 17.6325 7.89995 16.6516 7.89995 15.5695C7.89995 13.4017 9.62888 11.6391 11.7784 11.5945Z"
          fill="#00F2EA" />
        <circle cx="12.9999" cy="13.0001" r="12.5001" stroke="white" />
      </svg>
    {/if}
  </div>
{/if}

<div class="post-information" on:click|preventDefault|stopPropagation={handleRegularClick}>
  {#if author}
    <div class="author-information">
      {#if showPlatformBottom}
        <div class="icon-container">
          <div class="icon-container">
            <div class="author-icon" style="background: url('{author['avatar']}'); background-size: contain;"></div>
            <div class="platform-icon">
              {#if instagram}
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                  <rect x="1.07227" y="1.27734" width="16" height="16" rx="8" fill="white" />
                  <circle cx="9.07227" cy="9.27734" r="8.5" fill="white" stroke="white" />
                  <path
                    d="M9.10945 10.8962C8.2307 10.8962 7.51756 10.173 7.51756 9.2773C7.51756 8.38164 8.2307 7.65836 9.10945 7.65836C9.9882 7.65836 10.7013 8.38164 10.7013 9.2773C10.7013 10.173 9.9882 10.8962 9.10945 10.8962Z"
                    fill="url(#paint0_radial_548_87523)" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.0393 5.32287C9.76283 5.2629 8.47459 5.2707 7.19785 5.32213L7.1796 5.32287C6.71656 5.34315 6.46308 5.42088 6.29409 5.48848C5.87399 5.65398 5.55117 5.98809 5.3883 6.40779C5.3207 6.58016 5.24297 6.83703 5.22269 7.31021C5.16262 8.61449 5.16262 9.93329 5.22269 11.2376C5.24635 11.7107 5.32408 11.9676 5.3883 12.14C5.55093 12.5591 5.87488 12.8942 6.29409 13.0593C6.46308 13.1235 6.71318 13.2046 7.1796 13.2249C8.46121 13.2851 9.75773 13.2851 11.0393 13.2249C11.5024 13.2046 11.7559 13.1269 11.9248 13.0593C12.3449 12.8938 12.6678 12.5597 12.8306 12.14C12.8982 11.9676 12.976 11.7107 12.9962 11.2376C13.0563 9.93329 13.0563 8.61449 12.9962 7.31021C12.9726 6.83703 12.8948 6.58016 12.8306 6.40779C12.668 5.98872 12.344 5.65362 11.9248 5.48848C11.7559 5.42426 11.5057 5.34315 11.0393 5.32287ZM9.10945 6.78298C7.75415 6.78298 6.65909 7.89833 6.65909 9.2773C6.65909 10.6563 7.75753 11.7716 9.10945 11.7716C10.4614 11.7716 11.5598 10.6563 11.5598 9.2773C11.5598 7.89833 10.4614 6.78298 9.10945 6.78298ZM12.229 6.68494C12.229 7.006 11.9733 7.26627 11.6578 7.26627C11.3424 7.26627 11.0866 7.006 11.0866 6.68494C11.0866 6.36387 11.3424 6.1036 11.6578 6.1036C11.9733 6.1036 12.229 6.36387 12.229 6.68494Z"
                    fill="url(#paint1_radial_548_87523)" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M1.07227 9.50712V9.0745C1.19394 4.58947 5.09761 1.06431 9.49136 1.28738C13.5742 1.49692 16.9641 4.89027 17.0723 9.0745V9.50036C16.9641 13.6102 13.6891 16.963 9.70091 17.2773H8.4808C4.51629 16.9664 1.1838 13.644 1.07227 9.50712ZM7.14242 4.45087C8.44958 4.38987 9.76935 4.38987 11.0765 4.45087C11.5835 4.47453 11.9316 4.55565 12.2358 4.67732C12.8804 4.93377 13.384 5.45364 13.6316 6.10023C13.7499 6.41117 13.8311 6.76268 13.8547 7.27979L13.855 7.28761C13.9071 8.61516 13.9154 9.95418 13.8547 11.2815C13.8311 11.7986 13.7499 12.1535 13.6316 12.4611C13.3863 13.1086 12.8796 13.6278 12.2358 13.884C11.9316 14.0056 11.5835 14.0868 11.0765 14.1104C9.76931 14.1714 8.44964 14.171 7.14242 14.1104C6.63545 14.0868 6.28733 14.0056 5.98315 13.884C5.33857 13.6275 4.83492 13.1077 4.58729 12.4611C4.46899 12.1501 4.38788 11.7986 4.36422 11.2815L4.36391 11.2736C4.31185 9.9461 4.30349 8.6071 4.36422 7.27979C4.38788 6.76268 4.46899 6.40779 4.58729 6.10023C4.83266 5.4527 5.3393 4.93348 5.98315 4.67732C6.28733 4.55565 6.63545 4.47453 7.14242 4.45087Z"
                    fill="url(#paint2_radial_548_87523)" />
                  <defs>
                    <radialGradient
                      id="paint0_radial_548_87523"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(1.36449 15.81) rotate(-86.9999) scale(23.1324 19.6622)">
                      <stop stop-color="#FED576" />
                      <stop offset="0.2634" stop-color="#FF6E2A" />
                      <stop offset="0.6091" stop-color="#E42995" />
                      <stop offset="1" stop-color="#4864EF" />
                    </radialGradient>
                    <radialGradient
                      id="paint1_radial_548_87523"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(1.36449 15.81) rotate(-86.9999) scale(23.1324 19.6622)">
                      <stop stop-color="#FED576" />
                      <stop offset="0.2634" stop-color="#FF6E2A" />
                      <stop offset="0.6091" stop-color="#E42995" />
                      <stop offset="1" stop-color="#4864EF" />
                    </radialGradient>
                    <radialGradient
                      id="paint2_radial_548_87523"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(1.36449 15.81) rotate(-86.9999) scale(23.1324 19.6622)">
                      <stop stop-color="#FED576" />
                      <stop offset="0.2634" stop-color="#FF6E2A" />
                      <stop offset="0.6091" stop-color="#E42995" />
                      <stop offset="1" stop-color="#4864EF" />
                    </radialGradient>
                  </defs>
                </svg>
              {:else}
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                  <rect x="1" y="1.41406" width="16" height="16" rx="8" fill="white" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M1 9.64384V9.21122C1.12167 4.72619 5.02535 1.20103 9.4191 1.42409C13.5019 1.63364 16.8918 5.02699 17 9.21122V9.63708C16.8918 13.747 13.6168 17.0997 9.62864 17.4141H8.40853C4.44402 17.1031 1.11153 13.7807 1 9.64384Z"
                    fill="black" />
                  <path
                    d="M10.8824 8.20078C11.4437 8.60339 12.1312 8.84027 12.8737 8.84027V7.40628C12.7332 7.40631 12.593 7.39161 12.4555 7.36238V8.49113C11.7131 8.49113 11.0256 8.25424 10.4643 7.85166V10.778C10.4643 12.2419 9.28174 13.4286 7.82312 13.4286C7.27887 13.4286 6.77302 13.2635 6.35281 12.9803C6.83241 13.4724 7.50125 13.7777 8.24121 13.7777C9.69992 13.7777 10.8825 12.591 10.8825 11.1271L10.8824 8.20078ZM11.3983 6.75406C11.1115 6.4396 10.9232 6.03322 10.8824 5.58394V5.3995H10.4861C10.5859 5.97053 10.9261 6.45838 11.3983 6.75406ZM7.27538 11.8569C7.11514 11.646 7.02854 11.3881 7.02893 11.1229C7.02893 10.4533 7.5698 9.91047 8.2371 9.91047C8.36146 9.91044 8.48507 9.92955 8.60359 9.96729V8.50125C8.46509 8.4822 8.3253 8.47412 8.18558 8.47708V9.61817C8.06698 9.58043 7.9433 9.56127 7.81891 9.56139C7.15162 9.56139 6.61077 10.1042 6.61077 10.7738C6.61077 11.2473 6.88112 11.6572 7.27538 11.8569Z"
                    fill="#FF004F" />
                  <path
                    d="M10.4643 7.85166C11.0256 8.25424 11.7131 8.49113 12.4555 8.49113V7.36238C12.0411 7.27378 11.6742 7.05639 11.3983 6.75406C10.9261 6.45838 10.5859 5.97053 10.4861 5.3995H9.44512V11.127C9.44277 11.7947 8.90281 12.3354 8.23695 12.3354C7.84457 12.3354 7.49615 12.1477 7.27538 11.8569C6.88112 11.6572 6.61077 11.2473 6.61077 10.7738C6.61077 10.1042 7.15162 9.56139 7.81891 9.56139C7.94676 9.56139 8.06999 9.58136 8.18558 9.61817V8.47708C6.75259 8.50679 5.59996 9.68188 5.59996 11.127C5.59996 11.8485 5.88701 12.5024 6.35281 12.9803C6.77302 13.2635 7.27887 13.4286 7.82312 13.4286C9.28174 13.4286 10.4643 12.2419 10.4643 10.778V7.85166Z"
                    fill="white" />
                  <path
                    d="M12.4555 7.36238L12.4555 7.05715C12.0817 7.05772 11.7154 6.9527 11.3983 6.75406C11.679 7.06247 12.0486 7.27513 12.4555 7.36238ZM10.4861 5.3995C10.4766 5.34493 10.4692 5.29001 10.4642 5.23487V5.05043H9.02692V10.778C9.02462 11.4456 8.4847 11.9863 7.81878 11.9863C7.62327 11.9863 7.43885 11.9397 7.27538 11.8569C7.49615 12.1477 7.84457 12.3354 8.23695 12.3354C8.90281 12.3354 9.44277 11.7947 9.44512 11.127V5.3995H10.4861ZM8.18558 8.47708L8.18551 8.15221C8.06541 8.13573 7.94433 8.12746 7.8231 8.12752C6.36433 8.12749 5.18182 9.3142 5.18182 10.778C5.18182 11.6957 5.64658 12.5045 6.35281 12.9803C5.88701 12.5024 5.59996 11.8485 5.59996 11.127C5.59996 9.68188 6.75259 8.50679 8.18558 8.47708Z"
                    fill="#00F2EA" />
                  <circle cx="9.00006" cy="9.41412" r="8.50006" stroke="white" />
                </svg>
              {/if}
            </div>
          </div>
        </div>
      {/if}
      <div class="name-container">
        <div class="name">{author['name']}</div>
        {#if author['verfied']}
          <div class="verified-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
              <rect x="0.0722656" y="0.5" width="16" height="16" rx="8" fill="white" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.07141 1.54968C4.23286 1.54968 1.12109 4.66145 1.12109 8.5C1.12109 12.3386 4.23286 15.4503 8.07141 15.4503C11.91 15.4503 15.0217 12.3386 15.0217 8.5C15.0217 4.66145 11.91 1.54968 8.07141 1.54968ZM11.8664 6.79115L10.9389 5.88023L7.24282 9.64352C7.10564 9.78319 6.88058 9.78319 6.7434 9.64352L5.20408 8.07621L4.2766 8.98713L5.81592 10.5544C6.46261 11.2129 7.52361 11.2129 8.1703 10.5544L11.8664 6.79115Z"
                fill="#0C8EE9" />
            </svg>
          </div>
        {/if}
      </div>
    </div>
  {/if}
  <div class="title">{postInformation['title']}</div>
</div>
